import CornerMedium from "../../icons/CornerMedium";
import CornerSmall from "../../icons/CornerSmall";
import CornerLarge from "../../icons/CornerLarge";

export const TabsSettings = [
  { label: "Layout", value: "layout", i18n: "layout" },
  { label: "Content", value: "content", i18n: "content" },
];

export const ContentLoadSettings = [
  { label: "Dynamic", value: "dynamic", i18n: "dynamic" },
  { label: "Manual", value: "manually", i18n: "manual" },
];

export const CORNERS_OPTIONS = [
  { icon: CornerSmall, value: 1 },
  { icon: CornerMedium, value: 8 },
  { icon: CornerLarge, value: 20 },
];

export const PagesVariants = {
  CARD: "card",
  MINI_CARD: "mini_card",
  LIST: "list",
};

export const BOOLEAN_OPTIONS = [
  { label: "Yes", i18n: "yes", value: true },
  { label: "No", i18n: "no", value: false },
];

export const PageElements = {
  DESCRIPTION: "description",
  AUTHOR: "author",
  DATE: "date",
  SPACE: "space",
  LIKES: "likes",
  COMMENTS: "comments",
};

export const DefaultActiveElements = [
  PageElements.SPACE,
  PageElements.AUTHOR,
  PageElements.DESCRIPTION,
  PageElements.DATE,
  PageElements.LIKES,
  PageElements.COMMENTS,
];
